import React from "react";
import './Staff.css'

function StaffHeader(){
     return(
            <div className="staffs">
                     <h5 className="h5">Know our doctors</h5>
                     <p className="pap">Get to know our professionals in the team</p>
    
             </div>
     )
}
export default StaffHeader;